import axios from "axios";
import { getErrorMessage, handleApiError } from "../utils/errorHandler";
import API_BASE_URL from "../config/api";

// Base URL for your Flask backend
const BASE_URL = API_BASE_URL;

// Create a new test request
export const createTestRequest = async (testRequestData) => {
  try {
    const response = await axios.post(`${BASE_URL}/test-requests`, testRequestData);
    return response.data;
  } catch (error) {
    console.error("Error creating test request:", error);
    
    // Extract user-friendly error message
    const errorMessage = getErrorMessage(error);
    
    // Show user-friendly alert
    handleApiError(error, "Failed to create test request. Please try again.");
    
    // Re-throw with user-friendly message
    const enhancedError = new Error(errorMessage);
    enhancedError.originalError = error;
    throw enhancedError;
  }
};

// Fetch all test requests
export const getTestRequests = async (page = 1, perPage = 50) => {
  try {
    const response = await axios.get(`${BASE_URL}/test-requests?page=${page}&per_page=${perPage}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching test requests:", error);
    throw error;
  }
};

// Fetch test request details
export const getTestRequestDetails = async (testRequestId) => {
  try {
    const response = await axios.get(`${BASE_URL}/test-requests/${testRequestId}/details`);
    return response.data;
  } catch (error) {
    console.error("Error fetching test request details:", error);
    throw error;
  }
};

// Update an existing test request
export const updateTestRequest = async (testRequestId, testRequestData) => {
  try {
    const response = await axios.put(`${BASE_URL}/test-requests/${testRequestId}`, testRequestData);
    return response.data;
  } catch (error) {
    console.error("Error updating test request:", error);
    
    // Extract user-friendly error message
    const errorMessage = getErrorMessage(error);
    
    // Show user-friendly alert
    handleApiError(error, "Failed to update test request. Please try again.");
    
    // Re-throw with user-friendly message
    const enhancedError = new Error(errorMessage);
    enhancedError.originalError = error;
    throw enhancedError;
  }
};

// Delete a test request
export const deleteTestRequest = async (testRequestId) => {
  try {
    // Try DELETE method first (standard approach)
    const response = await axios.delete(`${BASE_URL}/test-requests/${testRequestId}`);
    return response.data;
  } catch (error) {
    // If DELETE fails with 405 (Method Not Allowed), try POST workaround
    // This handles cases where reverse proxies don't forward DELETE requests
    if (error.response && error.response.status === 405) {
      console.warn("DELETE method not allowed, trying POST workaround...");
      try {
        const response = await axios.post(`${BASE_URL}/test-requests/${testRequestId}/delete`);
        return response.data;
      } catch (postError) {
        console.error("Error deleting test request (POST fallback):", postError);
        const errorMessage = getErrorMessage(postError);
        handleApiError(postError, "Failed to delete test request. Please try again.");
        const enhancedError = new Error(errorMessage);
        enhancedError.originalError = postError;
        throw enhancedError;
      }
    } else {
      // For other errors, handle normally
      console.error("Error deleting test request:", error);
      const errorMessage = getErrorMessage(error);
      handleApiError(error, "Failed to delete test request. Please try again.");
      const enhancedError = new Error(errorMessage);
      enhancedError.originalError = error;
      throw enhancedError;
    }
  }
};